import React, { useState } from "react";
import "./PlatformCard.scss";
import AddIcon from "../../../../assets/svg/add-icon.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import { useDispatch, useSelector } from "react-redux";
import { storeIgSocialToken, storeFbSocialToken, fetchTwitteroAuthToken, fetchTokenList } from "../../../../actions/tokensAction";
import SocialTokenScopeModal from "../../../MainContent/Tokens/SocialTokenScopeModal";
import moment from "moment";

import InstagramIcon from "../../../../assets/svg/instagram.svg";
import FacebookIcon from "../../../../assets/svg/facebook-icon.svg";
import XIcon from "../../../../assets/svg/x-logo-latest.svg";
import LinkedInIcon from "../../../../assets/svg/linkedin.svg";
import TikTokIcon from "../../../../assets/svg/tiktok-icon.svg";
import GMBIcon from "../../../../assets/svg/GMB.svg";
import PlayStoreIcon from "../../../../assets/svg/play-store.svg";
import TelegramIcon from "../../../../assets/svg/telegram-icon.svg";
import AppStoreIcon from "../../../../assets/appstore.png";

import { useGoogleLogin } from "@react-oauth/google";
import PlaystoreClientDetailsModal from "../../../MainContent/SMRSettings/Accounts/PlaystoreModal/PlaystoreClientDetailsModal";
import TelegramCredentialModal from "../../../MainContent/SMRSettings/Accounts/TelegramModal/TelegramCredentialModal";
import AppstoreCredentialModal from "../../../MainContent/SMRSettings/Accounts/AppstoreModal/AppstoreCredentialModal";

const PlatformCard = ({ platformDetails, tokenList }) => {
    const { name, icon_url } = platformDetails;
    const [openPermissionModal, setOpenPermissionModal] = useState(false);
    const [platform, setPlatform] = useState({});

    const [showPlaystoreClientDetailsModal, setShowPlaystoreClientDetailsModal] = useState(false);
    const [showTelegramModal, setShowTelegramModal] = useState(false);
    const [showAppStoreModal, setShowAppStoreModal] = useState(false);

    const dispatch = useDispatch();
    const packageObj = useSelector((state) => state.globalReducer.packageObj);
    const getIcon = (platform) => {
        switch (platform) {
            case "Instagram":
                return InstagramIcon;
            case "Facebook":
                return FacebookIcon;
            case "X":
                return XIcon;
            case "LinkedIn":
                return LinkedInIcon;
            case "TikTok":
                return TikTokIcon;
            case "Google Business":
                return GMBIcon;
            case "Google Play Store":
                return PlayStoreIcon;
            case "App Store":
                return AppStoreIcon;
            case "Telegram":
                return TelegramIcon;

            default:
                break;
        }
    };

    const storeFbSocialTokens = (data) => {
        dispatch(storeFbSocialToken(data));
    };
    const storeIgSocialTokens = (data) => {
        dispatch(storeIgSocialToken(data));
    };

    const handleTwitterAuthentication = () => {
        dispatch(fetchTwitteroAuthToken("token_page"))
            .then((resp) => {
                let oAuthToken = resp.value.data.oauth_token;
                window.location.href = `https://api.twitter.com/oauth/authenticate?oauth_token=${oAuthToken}`;
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const handleTiktokAuthenticate = () => {
        const csrfState = Math.random().toString(36).substring(2);
        const uri = `https://www.tiktok.com/auth/authorize/?client_key=awxcxp77l3djezax&scope=user.info.basic,video.list&response_type=code&redirect_uri=${window.location.origin}/social-tokens/oauth-callback&state=${csrfState},tiktok`;
        window.location.href = uri;
    };

    const handleLinkedinAuthenticate = () => {
        const unique_identifier = moment.now();
        const uri = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${process.env.REACT_APP_LINKEDIN_CLIENT_ID}&redirect_uri=${window.location.origin}/social-tokens/oauth-callback&state=${unique_identifier},socialToken&scope=r_liteprofile,r_emailaddress,rw_organization_admin,r_organization_social,r_basicprofile`;
        window.location.href = uri;
    };

    const handleGoogleBusinessAuthentication = useGoogleLogin({
        flow: "auth-code",
        scope: "https://www.googleapis.com/auth/business.manage",
        onSuccess: (CodeResponse) => {
            let param = {};
            param["code"] = CodeResponse.code;
            param["redirect_url"] = window.location.origin;

            props.getGMBToken(param).then((res) => {
                let accountParam = {};

                accountParam["token"] = res.value.data.access_token;

                if (res.value.status == "success") {
                    props.getGMBAccount(accountParam).then((val) => {
                        if (val.value?.accounts?.length > 0) {
                            setShowAccountListModal(true);
                        } else {
                            toast.error("Please select the required permission to continue");
                        }
                    });
                } else {
                    toast.error("Failed to authenticate.");
                }
            });
        },

        onError: () => {
            toast.error("Error in authorizing.Please try again");
        },
    });

    const mainAuthForPlayStore = useGoogleLogin({
        flow: "auth-code",
        scope: "https://www.googleapis.com/auth/androidpublisher",
        onSuccess: (CodeResponse) => {
            if (CodeResponse.code) responseGooglePlaystore(CodeResponse);
        },

        onError: (errResponse) => {
            console.log("first", errResponse);
            dispatch(changeGoogleCLientId("626488198253-v37qlu0s8mc6qt43jj6u2k1asfqfvu7e.apps.googleusercontent.com"));

            toast.error("Error in authorizing.Please try again");
        },
    });

    const playstoreLogin = async () => {
        if (clientId !== "626488198253-v37qlu0s8mc6qt43jj6u2k1asfqfvu7e.apps.googleusercontent.com") {
            console.log("issue with client id", clientId);
        }
        mainAuthForPlayStore();
        setTimeout(() => {
            dispatch(changeGoogleCLientId("626488198253-v37qlu0s8mc6qt43jj6u2k1asfqfvu7e.apps.googleusercontent.com"));
        }, 100);
    };

    const handlePlayStoreAuthentication = () => {
        setShowPlaystoreClientDetailsModal(true);
    };

    const fetchToken = () => {
        dispatch(fetchTokenList());
    };

    const handleTelegramAuthentication = () => {
        setShowTelegramModal(true);
    };
    const handleAppeStoreAuthentication = () => {
        setShowAppStoreModal(true);
    };

    const getPopupContent = () => {
        return (
            <>
                <div className="popup__container">
                    <div className="heading__container">
                        <p className="heading">{`${name}  Account Connected `}</p>
                    </div>
                    <div className="profile__container">
                        {/* {Object.keys(tokenList).length > 0 && */}
                        {tokenList[name.toLowerCase()]?.count > 0 &&
                            tokenList[name.toLowerCase()]?.profiles.map((profileName, idx) => (
                                <p key={idx} className="profile__name">
                                    {" "}
                                    {profileName}
                                </p>
                            ))}
                    </div>
                </div>
            </>
        );
    };
    const count = tokenList?.[name.toLowerCase()]?.count;

    const handleAuthenticatePlatform = (platformName) => {
        let platformDetails = null;
        if (name === "Facebook") platformDetails = { name: "facebook", appId: process.env.REACT_APP_FB_APP_ID };
        if (name === "Instagram") platformDetails = { name: "instagram", appId: process.env.REACT_APP_IG_APP_ID };

        if (platformDetails) {
            setOpenPermissionModal(true);
            setPlatform(platformDetails);
        } else {
            switch (platformName) {
                case "Twitter":
                    handleTwitterAuthentication();
                    break;
                case "X":
                    handleTwitterAuthentication();
                    break;
                case "LinkedIn":
                    handleLinkedinAuthenticate();
                    break;
                case "TikTok":
                    handleTiktokAuthenticate();
                    break;
                case "Google Business":
                    handleGoogleBusinessAuthentication();
                    break;
                case "Google Play Store":
                    handlePlayStoreAuthentication();
                    break;
                case "Telegram":
                    handleTelegramAuthentication();
                    break;
                case "App Store":
                    handleAppeStoreAuthentication();
                    break;

                default:
                    break;
            }
        }
    };

    return (
        <div className="platform__card">
            <div className="top__section">
                <Popup
                    className="popup-team"
                    content={getPopupContent()}
                    on="click"
                    trigger={<div className={`count__icon ${!count ? "hide__count" : " "}`}>{count}</div>}
                    size="small"
                    position="left center"
                    disabled={!count ? true : false}
                    inverted
                />

                <Popup
                    content={` Add ${name} account`}
                    trigger={<img className="add__icon" alt="" src={AddIcon} onClick={() => handleAuthenticatePlatform(name)} />}
                    size="mini"
                    position="top center"
                    inverted
                />
            </div>

            <img className="platform__icon" onClick={() => handleAuthenticatePlatform(name)} alt={name} src={getIcon(name)} />
            <p className="platform__name">{name}</p>

            <SocialTokenScopeModal
                open={openPermissionModal}
                onClose={() => {
                    setOpenPermissionModal(false);
                }}
                platform={platform}
                storeFbSocialToken={storeFbSocialTokens}
                storeIgSocialToken={storeIgSocialTokens}
                packageObj={packageObj}
                selectAll
            />

            <PlaystoreClientDetailsModal
                open={showPlaystoreClientDetailsModal}
                hideModal={() => setShowPlaystoreClientDetailsModal(false)}
                authenticatePlaystore={playstoreLogin}
            />
            {showTelegramModal && <TelegramCredentialModal hideModal={() => setShowTelegramModal(false)} fetchToken={fetchToken} />}
            {showAppStoreModal && <AppstoreCredentialModal hideModal={() => setShowAppStoreModal(false)} fetchToken={fetchToken} />}
        </div>
    );
};

export default PlatformCard;
